// file:///c:/Users/Kalya/OneDrive/Desktop/fleet%20css/components/ContentWrapper.jsx
import React from "react";

export default function ContentWrapper({ children }) {
  return <>{children}</>;
}
